package org.example.project.enginemodule

import org.example.project.utils.All

fun normalizeModuleTag(raw: String): String = raw.trim().replace(Regex("\\s+"), " ").take(80)

fun resolveModuleCategory(module: All): String = normalizeModuleTag(module.modulKategorie)

fun applyModuleCategory(module: All, category: String): All {
    val normalizedCategory = normalizeModuleTag(category)
    return module.copy(
        modulTyp = normalizedCategory,
        modulKategorie = normalizedCategory
    )
}

fun shouldWarnOnSysModuleSave(
    initialEnabledScreens: Set<String>,
    initialVersion: String,
    module: All
): Boolean {
    val currentEnabledScreens = module.modulScreens.filterValues { it }.keys.toSet()
    val currentVersion = module.modulReferenz.trim().ifBlank { "0.0.0" }
    return currentEnabledScreens != initialEnabledScreens && currentVersion == initialVersion
}

fun prepareSysModuleForSave(updated: All, existing: All?): All {
    val normalized = applyModuleCategory(updated.normalizeScreens(), resolveModuleCategory(updated))
    return normalized.copy(
        modulScreens = normalized.modulScreens.filterValues { it }
    )
}
